import mutations from './appointment.mutations'
import actions from './appointment.actions'
import getters from './appointment.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
